<section
  class="custom-modal"
  tabindex="0"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'modal-title'">
  <app-modal-header
    [close]="onCancel"
    [title]="title">
  </app-modal-header>

  <div class="modal-body">
    <div class="form-field">
      <label [for]="'textarea-input'" class="form-label">
        {{ label }}
      </label>
      <textarea
        id="textarea-input"
        class="form-textarea"
        [(ngModel)]="textareaValue"
        [placeholder]="placeholder"
        rows="6"
        [attr.aria-label]="label"></textarea>
    </div>
  </div>

  <footer class="modal-footer">
    <app-shared-button
      class="secondary"
      [colour]="'primary'"
      (click)="onCancel()">
      Cancel
    </app-shared-button>
    <app-shared-button
      [fill]="true"
      (click)="onSave()">
      Save
    </app-shared-button>
  </footer>
</section>
